<template>
    <div class="marketing-sms-form-senders-custom-list">      
      <div class="marketing-sms-form-senders-custom-list-time-filter-container" :class="{'time-filter-container-opened': isTimeFilterActive}">
        <v-checkbox v-model="isTimeFilterActive"
                    :label="$t('message.marketingGenerics.message.enablePeriodFilter')"
                    ></v-checkbox>

        <div v-if="isTimeFilterActive"
             class="marketing-sms-form-senders-custom-list-time-filter-container-body">
            <div class="flex-row">
                <div>
                    <h5 class="text-muted">{{ $t('message.marketingGenerics.message.entryCriteria') }}:</h5>
                    <app-select :data-title="$t('message.spots.message.select')"
                                v-model="form.timeFilterType"
                                :data-search="false"
                                data-menu-width="200px"                                
                                class="time-type-select"
                                :data-items="timeTypes"/>        
                </div>
                <div>
                    <h5 class="text-muted">{{ $t('message.marketingGenerics.message.periodType') }}:</h5>
                    <v-radio-group v-model="form.timeFilter.type" >
                        <v-radio :label="daysLabel" value="NUMBER_OF_DAYS"></v-radio>
                        <v-radio :disabled="isBirthdateType" :label="$t('message.marketingGenerics.message.period')" value="PERIOD"></v-radio>
                    </v-radio-group>
                </div>
            </div>
            <div v-if="isPeriodType"
                 class="dates">
                <app-box-wrapper :data-label="$t('message.generics.message.startDate')"
                                data-icon="mdi-calendar-range">

                    <app-date-picker v-model="form.timeFilter.startPeriod"
                                    :readonly="readonly"
                                    menu-width="auto"
                                    ></app-date-picker>

                </app-box-wrapper>

                <app-box-wrapper :data-label="$t('message.generics.message.endDate')"
                                data-icon="mdi-calendar-range">

                    <app-date-picker v-model="form.timeFilter.endPeriod"
                                    :readonly="readonly"
                                    menu-width="auto"
                                    ></app-date-picker>

                </app-box-wrapper>
            </div>
            <div v-else
                 class="number-of-days-input-container">
                <h5 class="text-muted custom-h5">{{ $t('message.marketingGenerics.message.numberOfDays') }}:</h5>
                <v-text-field class="custom-text-field"
                              type="number"
                              v-model="form.timeFilter.days"
                              validate="'required'"
                              
                              ref="daysInput"></v-text-field>
            </div>

        </div>  

      </div>      

      <div class="segment">
        <h4 class="text-muted">{{ $t('message.marketingGenerics.message.genderAndAge') }}</h4>

        <app-tab-selector v-model="form.gender"
                          :readonly="readonly"
                          :data-tabs="tabs"
                          ></app-tab-selector>

        <app-range-slider :value="[form.startAge, form.endAge]"
                          :readonly="readonly"
                          :data-label="$t('message.campaigns.message.yearsOld')"
                          @input="sliderInput"></app-range-slider>       
        
      </div>
    </div>
</template>
  
<script>
import AppRangeSlider from "@components/RangeSlider";
import AppTabSelector from "@components/TabSelector";
import vModel from "@mixins/v-model";
import AppSelect from '@components/Select'
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import {cloneDeep} from 'lodash'

export default {
    components: {
        AppRangeSlider,
        AppTabSelector,
        AppSelect,
        AppBoxWrapper,
        AppDatePicker,
    },

    data() {
        return {
            isTimeFilterActive: false,
            form: {
                timeFilterType: undefined,
                gender:  null,
                startAge:  0,
                endAge: 100,
                timeFilter: {
                    type:  "PERIOD",
                    startPeriod:  new Date().toISOString().substring(0, 10),
                    endPeriod:  new Date().toISOString().substring(0, 10),
                    days:  undefined   
                }

            },
        };
    },

    props: {
        value: {
            type: Object,            
        },
    },

    watch: {
        timeType(val) {
            if(val === "NUMBER_OF_DAYS") {
                this.$nextTick(() => {                    
                    this.$refs.daysInput.focus();
                });
            }
        },
        isBirthdateType(val) {
            if(val) {
                this.form.timeFilter.type = "NUMBER_OF_DAYS"
            }
        },
        form: {
            deep: true,
            handler() {               
                this.emitInput(this.form)
            }
        },
        isTimeFilterActive(val) {
            if(!val) {
                this.form.timeFilterType = undefined
                this.$emit('change-timeFilterActive', false)
            } else {
                this.$emit('change-timeFilterActive', true)
            }
        },       
          
    },

    computed: {
        tabs() {
            return [
                { value: null, label: this.$t('message.campaigns.message.everyone') },
                { value: "MASCULINO", label: this.$t('message.campaigns.message.men') },
                { value: "FEMININO", label: this.$t('message.campaigns.message.women') },
                { value: "NAO_DECLARADO", label: this.$t('message.generics.message.notInformed') },
            ]
        },
        timeTypes() {
            return [
                {id: "ACCESS", label: this.$t('message.marketingGenerics.message.access') },
                {id: "REGISTER", label: this.$t('message.marketingGenerics.message.register') },
                {id: "BIRTHDATE", label: this.$t('message.marketingGenerics.message.birthday') },
            ]
        },
        isPeriodType() {
            return this.form.timeFilter.type === "PERIOD"
        },
        isBirthdateType() {
            return this.form.timeFilterType === "BIRTHDATE"
        },
        timeType() {
            return this.form.timeFilter ? this.form.timeFilter.type : null
        },
        
        timeFilterActive() {
            return this.isTimeFilterActive
        },
        daysLabel() {
            return this.isBirthdateType ? this.$t('message.marketingGenerics.message.inXDays') : this.$t('message.marketingGenerics.message.pastDays')
        },        
    },

    methods: {
        sliderInput(evt) {
            this.form.startAge = evt[0];
            this.form.endAge = evt[1];
            this.emitInput(this.form)
        },
        setFormData(val, key) {
            const newVal = cloneDeep(this.val)
            newVal[key] = val
            if(this.isPeriodType) {
                delete newVal.days
            } else {
                delete newVal.startPeriod
                delete newVal.endPeriod
            }
            
            this.emitInput(newVal)
        },
        setTimeFilter(val, key) {
            this.timeFilter[key] = val
            const newVal = cloneDeep(this.val)
            newVal.timeFilter = this.timeFilter
            this.emitInput(newVal)
        },
        emitInput(val) {           
            this.$emit("input", val)
        },
        emitChangeTimeFilterActive(val) {
            if(!val) this.setFormData(undefined, "timeFilterType")
            this.$emit('change-timeFilterActive', val)
        },
        setInitialData() {
            if(this.val.timeFilter) {
                this.form = {
                    timeFilterType: this.val.timeFilterType,
                    gender:  this.val.gender ? this.val.gender : null,
                    startAge:  this.val.startAge,
                    endAge: this.val.endAge,
                    timeFilter: {
                        type:  this.val.timeFilter.type,
                        startPeriod:  this.val.timeFilter.startPeriod,
                        endPeriod:  this.val.timeFilter.endPeriod,
                        days:  this.val.timeFilter.days   
                    }
                }
            } else {
                this.form.startAge = this.val.startAge
                this.form.endAge = this.val.endAge
                this.form.gender = this.val.gender ? this.val.gender : null
            }            
        }       
    },

    mounted() {        
        if(this.val) this.setInitialData()             
        if(this.val && this.val.timeFilterType) this.isTimeFilterActive = true
    },   

    mixins: [vModel],
};
</script>
  
<style lang="scss" scoped>
    .marketing-sms-form-senders-custom-list {
        position: relative;
        padding: 0 20px 10px;
        border: 2px solid #c4c4c4;
        border-radius: 8px;
        /* max-height: 350px;
        overflow-y: auto; */
        display: flex;
        flex-direction: column;
        /* margin-bottom: 25px; */
        .marketing-sms-form-senders-custom-list-time-filter-container {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 0 0 0;
            

            .marketing-sms-form-senders-custom-list-time-filter-container-body {

                .flex-row {
                    display: flex;
                    gap: 45px;

                    .test {
                        font-weight: 500;
                    }

                    .time-type-select {
                        margin: 0 auto;
                    }
                }

                .dates {
                    display: flex;
                    gap: 30px
                }

                .number-of-days-input-container {
                    display: flex;
                    gap: 50px;
                    /* flex-direction: column; */
                    /* align-items: center; */                    

                    .custom-h5 {
                        align-self: end;
                    }

                    .custom-text-field {
                       margin-bottom: 0;
                      width: 40px;
                    }

                    .v-input {                        
                        ::v-deep .v-text-field__details {
                            display: none;
                        }

                        ::v-deep input {
                            /* Chrome, Safari, Edge, Opera */
                            &::-webkit-outer-spin-button,
                            &::-webkit-inner-spin-button {
                            -webkit-appearance: none;
                            margin: 0;                           
                            }

                            /* Firefox */
                            &[type="number"] {
                            -moz-appearance: textfield;
                            padding-bottom: 0;
                            width: 30px;
                            }
                        }
                    }
                }
            }
        }

        .time-filter-container-opened {
            margin-bottom: 30px;
        }

        .segment {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            & > *:not(:first-child) {
            margin-top: 10px;
            }
        }


        .marketing-sms-form-senders-list-table {
            overflow-y: auto;
        }
    }
</style>
  